module.exports = __webpack_public_path__ + "707ad48cbfa1db9d1a54c61c70104bc6.png";